import { AllSeriesDataClass1d } from "./AllSeriesDataClass1d.js";

let seriesArray = [
  {
    seriesName: "10",
    startNumber: 10,
    multiply: 2 * 1,
    fieldName:  '',
    printStartNUmber:1000

  },
  {
    seriesName: "30",
    startNumber: 30,
    multiply: 2 * 1,
    fieldName:  '',
    printStartNUmber:3000
  },
  {
    seriesName: "50",
    startNumber: 50,
    multiply: 2 * 1,
    fieldName:  '',
    printStartNUmber:5000
  },
];

let seriesStore = new Array(1);

for (let s = 0; s < seriesArray.length; s++) {
  seriesStore[s] = new AllSeriesDataClass1d(seriesArray[s]);
  seriesStore[s].setSeriesPart();
}

export let fpGroupState = [
  {
    id: 0,
    activeInput: [0, 5, 50, 55],
  },
  {
    id: 1,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 2,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 3,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 4,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 5,
    activeInput: [0, 5, 50, 55],
  },
  {
    id: 6,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 7,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 8,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 9,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 10,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 11,
    activeInput: [11, 16, 61, 66],
  },
  {
    id: 12,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 13,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 14,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 15,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 16,
    activeInput: [11, 16, 61, 66],
  },
  {
    id: 17,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 18,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 19,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 20,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 21,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 22,
    activeInput: [22, 27, 72, 77],
  },
  {
    id: 23,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 24,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 25,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 26,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 27,
    activeInput: [22, 27, 72, 77],
  },
  {
    id: 28,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 29,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 30,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 31,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 32,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 33,
    activeInput: [33, 38, , 83, 88],
  },
  {
    id: 34,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 35,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 36,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 37,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 38,
    activeInput: [33, 38, , 83, 88],
  },
  {
    id: 39,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 40,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 41,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 42,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 43,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 44,
    activeInput: [44, 49, , 94, 99],
  },
  {
    id: 45,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 46,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 47,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 48,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 49,
    activeInput: [44, 49, , 94, 99],
  },
  {
    id: 50,
    activeInput: [0, 5, 50, 55],
  },
  {
    id: 51,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 52,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 53,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 54,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 55,
    activeInput: [0, 5, 50, 55],
  },
  {
    id: 56,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 57,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 58,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 59,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 60,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 61,
    activeInput: [11, 16, 61, 66],
  },
  {
    id: 62,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 63,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 64,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 65,
    activeInput: [1, 6, 10, 15, 51, 56, 60, 65],
  },
  {
    id: 66,
    activeInput: [11, 16, 61, 66],
  },
  {
    id: 67,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 68,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 69,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 70,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 71,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 72,
    activeInput: [22, 27, 72, 77],
  },
  {
    id: 73,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 74,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 75,
    activeInput: [2, 7, 20, 25, 52, 57, 70, 75],
  },
  {
    id: 76,
    activeInput: [12, 17, 21, 26, 62, 67, 71, 76],
  },
  {
    id: 77,
    activeInput: [22, 27, 72, 77],
  },
  {
    id: 78,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 79,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 80,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 81,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 82,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 83,
    activeInput: [33, 38, , 83, 88],
  },
  {
    id: 84,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 85,
    activeInput: [3, 8, 30, 35, 53, 58, 80, 85],
  },
  {
    id: 86,
    activeInput: [13, 18, 31, 36, 63, 68, 81, 86],
  },
  {
    id: 87,
    activeInput: [23, 28, 32, 37, 73, 78, 82, 87],
  },
  {
    id: 88,
    activeInput: [33, 38, , 83, 88],
  },
  {
    id: 89,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 90,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 91,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 92,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 93,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 94,
    activeInput: [44, 49, , 94, 99],
  },
  {
    id: 95,
    activeInput: [4, 9, 40, 45, 54, 59, 90, 95],
  },
  {
    id: 96,
    activeInput: [14, 19, 41, 46, 64, 69, 91, 96],
  },
  {
    id: 97,
    activeInput: [24, 29, 42, 47, 74, 79, 92, 97],
  },
  {
    id: 98,
    activeInput: [34, 39, 43, 48, 84, 89, 93, 98],
  },
  {
    id: 99,
    activeInput: [44, 49, , 94, 99],
  },
];

export let cross = [];
cross[0] = {activeInput: [0, 11, 22, 33, 44, 55, 66, 77, 88, 99]}
cross[9] = {activeInput: [9, 18, 27, 36, 45, 54, 63, 72, 81, 90]}
cross[90] = {activeInput: [9, 18, 27, 36, 45, 54, 63, 72, 81, 90]}
cross[99] = {activeInput: [0, 11, 22, 33, 44, 55, 66, 77, 88, 99]}

export let Box25 = [
    {activeInput : [0,1,2,3,4,10,11,12,13,14,20,21,22,23,24,30,31,32,33,34,40,41,42,43,44]},
    {activeInput : [5,6,7,8,9,15,16,17,18,19,25,26,27,28,29,35,36,37,38,39,45,46,47,48,49]},
    {activeInput : [50,51,52,53,54,60,61,62,63,64,70,71,72,73,74,80,81,82,83,84,90,91,92,93,94]},
    {activeInput : [55,56,57,58,59,65,66,67,68,69,75,76,77,78,79,85,86,87,88,89,95,96,97,98,99]}
]



// console.log('seriesStore: ', seriesStore);
export { seriesStore };
